import serviceApi from "../api/apiClient";

export const placeOrderApi = (data) =>
  serviceApi.post("bookservice/book", data);

export const getMyOrdersApi = () => serviceApi.get("/service/book");
